export default "__VITE_ASSET__DOCYReJz__"